import { render, staticRenderFns } from "./InstructorSignupSuccessComponent.vue?vue&type=template&id=3f2112f2&"
import script from "./InstructorSignupSuccessComponent.vue?vue&type=script&lang=js&"
export * from "./InstructorSignupSuccessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports